import React from 'react';
import avatar from '../assets/images/my-avatar.png';
import linkedinIcon from '../assets/images/logo-linkedin.svg';
import instagramIcon from '../assets/images/logo-instagram.svg';
import tiktokIcon from '../assets/images/logo-tiktok.svg';
import CalendarIcon from '../assets/images/calendar-sharp.svg';
import CallIcon from '../assets/images/call-sharp.svg';
import LocationIcon from '../assets/images/location-sharp.svg';
import MailIcon from '../assets/images/mail-sharp.svg';

function Sidebar() {
    const toggleSidebar = () => {
        const sidebar = document.querySelector('[data-sidebar]');
        sidebar.classList.toggle('active');
    };

    return (
        <aside className="sidebar" data-sidebar="">
            <div className="sidebar-info">
                <figure className="avatar-box">
                    <img src={avatar} alt="Paola Valle Zárate" width="80" />
                </figure>
                <div className="info-content">
                    <h1 className="name" title="Paola Valle Zárate">Paola Valle Zárate</h1>
                    <p className="title">Project Manager</p>
                </div>
                <button className="info_more-btn" data-sidebar-btn="" onClick={toggleSidebar}>
                    <span>Contacto</span>
                </button>
            </div>
            <div className="sidebar-info_more">
                <div className="separator"></div>
                <ul className="contacts-list">
                    <li className="contact-item">
                        <div className="icon-box">
                            <img src={MailIcon} alt="Mail" className="social-icon" />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Email</p>
                            <a href="mailto:imagenpaovalle@gmail.com" className="contact-link">imagenpaovalle@gmail.com</a>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <img src={CallIcon} alt="Teléfono" className="social-icon" />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Teléfono</p>
                            <a href="tel:637476081" className="contact-link">637476081</a>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <img src={CalendarIcon} alt="Nacimiento" className="social-icon" />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Nacimiento</p>
                            <time>1998</time>
                        </div>
                    </li>
                    <li className="contact-item">
                        <div className="icon-box">
                            <img src={LocationIcon} alt="Ciudad" className="social-icon" />
                        </div>
                        <div className="contact-info">
                            <p className="contact-title">Ciudad</p>
                            <address>Alicante</address>
                        </div>
                    </li>
                </ul>
                <div className="separator"></div>
                <ul className="social-list">
                    <li className="social-item">
                        <a href="https://www.linkedin.com/in/paovallez" target="_blank" rel="noopener noreferrer" className="social-link">
                            <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                        </a>
                    </li>
                    <li className="social-item">
                        <a href="https://www.instagram.com/paovallez/" target="_blank" rel="noopener noreferrer" className="social-link">
                            <img src={instagramIcon} alt="Instagram" className="social-icon" />
                        </a>
                    </li>
                    <li className="social-item">
                        <a href="https://www.tiktok.com/@paovallez" target="_blank" rel="noopener noreferrer" className="social-link">
                            <img src={tiktokIcon} alt="TikTok" className="social-icon" />
                        </a>
                    </li>
                </ul>
            </div>
        </aside>
    );
}

export default Sidebar;
